import { SerializableObject } from './serializable-object';


/** The InvitationsLinksList domain object. */
export class InvitationsLinksList extends SerializableObject {
  invitationsIds: String[];
  membershipsIds: String[];

  public buildFromJSON(json: Object) {
    // json is not an actual JSON
    // the format is: ["invite:d5df48cc-847d-4c59-88ce-a86b00ffcd7e", "membership:5b084d01-181e-4070-afc6-a86b00ffcdea"]
    this.invitationsIds = [];
    this.membershipsIds = [];

    (json as string[]).forEach((invite) => {
      let membershipType: string;
      let inviteId: string;
      [membershipType, inviteId] = invite.split(":");

      if (membershipType === "invite") {
        this.invitationsIds.push(inviteId);
      } else if (membershipType === "membership") {
        this.membershipsIds.push(inviteId);
      }
    });
  }

}
